import React, { useState, useContext } from 'react';
import './imageviewer.css';
import { UserContext } from '../userContext/UserContext';

const ImageViewer = ({ images, initialIndex, onClose }) => {
    const [currentIndex, setCurrentIndex] = useState(initialIndex);
    const { sasToken } = useContext(UserContext);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }

    const handlePrev =() => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    }

    const renderFileContent = (fileUrl) => {
        const parts = fileUrl.split('.');
        const extension = parts[parts.length - 1]?.toLowerCase();

        if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension)) {
            // Render Image
            return <img src={`${fileUrl}?${sasToken}`} alt="Attachment" className="image-viewer-image" />;
        } else if (['mp4', 'webm', 'ogg'].includes(extension)) {
            // Render Video
            return (
                <video controls className="image-viewer-video">
                    <source src={`${fileUrl}?${sasToken}`} type={`video/${extension}`} />
                    Your browser does not support the video tag.
                </video>
            );
        } else if (['pdf'].includes(extension)) {
            // Render PDF
            return (
                <iframe
                    src={`${fileUrl}?${sasToken}`}
                    title="PDF Viewer"
                    className="image-viewer-pdf"
                    frameBorder="0"
                />
            );
        } else {
            // Render as a download link for unsupported file types
            return (
                <a href={`${fileUrl}?${sasToken}`} target="_blank" rel="noopener noreferrer" className="viewer-content-link">
                    Download File
                </a>
            );
        }
    };
    
    return (
        <div className="image-viewer-overlay">
            <div className="image-viewer-content">
                <button className="close-button" onClick={onClose}>&times;</button>
                <button className="prev-button" onClick={handlePrev}>&lt;</button>
                <div className="">
                    {renderFileContent(images[currentIndex])}
                </div>
                <button className="next-button" onClick={handleNext}>&gt;</button>
            </div>
        </div>
    )
}

export default ImageViewer;


